import React from 'react'
import {toast} from 'react-toastify';
export const Filter = (props) => {
  let filterData=props.filterData;
  const categary=props.categary;
  const setcategary=props.setcategary;
  function clickHandler(title){
      setcategary(title);
      toast.success(`You select ${title}`)
  }
  return (
    <div className='bg-bgDark2 flex justify-center p-4'>
        <div className='flex gap-3 text-lg text-white font-semibold flex-wrap'>

        {
           filterData.map((item) =>{


            if(item.title=== categary)
            {
              return(
                <button className='bg-[#161c49] py-2 px-3 rounded-md border-2' type="" key={item.id} onClick={()=> clickHandler(item.title)}>{item.title}</button>
            )

            }
            else{
              return(
                <button className='bg-[#3f4259] py-2 px-3 rounded-md' type="" key={item.id} onClick={()=> clickHandler(item.title)}>{item.title}</button>
            )

            }
          
           })
            
        }
            
        </div>
       
    </div>
  )
}
